import { companyTypes } from "../../../../../libs/company-types";

const genCompanyTypes = () => [...companyTypes];

export const useCompanyTypes = () => genCompanyTypes();
